export const fontSize = {
  base: { mobile: '10px', desktop: '16px' },
  md: '1rem',
  xl: '4rem',
};
